module.exports = __webpack_public_path__ + "img/QrCodeImage.05b9a1e5.png";